import { ParsedContent, ChartData } from '../types'

export function parseContent(content: string): ParsedContent[] {
  const parts: ParsedContent[] = []
  const chartRegex = /```chart\s*([\s\S]*?)```/g

  let lastIndex = 0
  let match

  while ((match = chartRegex.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: content.slice(lastIndex, match.index) })
    }

    try {
      const chartConfig: ChartData = JSON.parse(match[1].trim())
      parts.push({ type: 'chart', content: match[0], chartConfig })
    } catch {
      parts.push({ type: 'text', content: match[0] })
    }

    lastIndex = match.index + match[0].length
  }

  if (lastIndex < content.length) {
    parts.push({ type: 'text', content: content.slice(lastIndex) })
  }

  return parts
}
